import { Box, Typography } from "@mui/material";
import React from "react";

export default function NamePage({ name, subName, component }) {
  return (
    <Box
      sx={{
        width: "100%",
        pb: "12px",
        // mb: "12px",
        borderBottom: !!subName ? "1px solid var(--grey)" : "",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>{name}</Typography>
        {subName && <Typography sx={{ fontSize: "14px" }}>{subName}</Typography>}
      </Box>
      {component}
    </Box>
  );
}
